import { render, staticRenderFns } from "./PropertyCommentAssociation.vue?vue&type=template&id=f972fa1a&scoped=true&"
import script from "./PropertyCommentAssociation.vue?vue&type=script&lang=ts&"
export * from "./PropertyCommentAssociation.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyCommentAssociation.vue?vue&type=style&index=0&id=f972fa1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f972fa1a",
  null
  
)

export default component.exports